import { ALTERAR_TODAS_RESERVAS_ITINERARIO } from '../types'

export default function alterarTodasReservasItinerario (valor) {
  return {
    type: ALTERAR_TODAS_RESERVAS_ITINERARIO,
    payload: valor
  }
}